import { message } from "antd";
import { observable, action, flow } from "mobx";
import { registerHandler, getAllProfilesWithCampaigns } from "services/api";
import {
	getPrivateNetwork,
	deletePrivateSites,
	importPrivateSites
} from "services/privatenetworks";

class PrivateNetworkStore {
	constructor() {
		this.ui = this.initUI();
		this.ui.loadingPrivateNetwork = true;
	}

	@observable
	privateNetwork = {};

	@observable
	sites = [];

	@observable
	profiles = [];

	initUI = () => {
		const ui = {
			loadingPrivateNetwork: false,
			deletingPrivateSites: false,
			importPrivateSitesDialogVisible: false,
			importFromAccountProfileDialogVisible: false,
			importingPrivateSites: false,
			deletedPrivateSites: [],
			importedPrivateSites: []
		};

		return observable.object(ui);
	};

	@action
	deletePrivateSites = deletedPrivateSites => {
		this.ui.deletedPrivateSites = observable.array(deletedPrivateSites);
	};

	@action
	addPrivateSites = importedPrivateSites => {
		this.ui.importedPrivateSites = observable.array(importedPrivateSites);
	};

	@action
	showImportPrivateSitesDialog = () => {
		this.ui.importPrivateSitesDialogVisible = true;
	};

	@action
	showImportFromAccountProfileDialog = () => {
		this.ui.importFromAccountProfileDialogVisible = true;
	};

	@action
	hideImportFromAccountProfileDialog = () => {
		this.ui.importFromAccountProfileDialogVisible = false;
	};

	@action
	hideImportPrivateSitesDialog = () => {
		this.ui.importPrivateSitesDialogVisible = false;
	};

	remoteImportPrivateSites = flow(function*(payload) {
		this.importingPrivateSites = true;
		const response = yield importPrivateSites(
			this.privateNetwork.id,
			payload
		);
		this.importingPrivateSites = false;
	});

	remoteDeletePrivateSites = flow(function*(privateSites) {
		this.deletingPrivateSites = true;
		const response = yield deletePrivateSites(
			this.privateNetwork.id,
			privateSites
		);
		if (response == null) {
			message.error(
				"Failed to delelet selected private network sites",
				5
			);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		message.success("Successfully deleted selected private network sites");
	});

	loadPrivateNetwork = flow(function*(privateNetworkId) {
		this.ui = this.initUI();

		this.ui.loadingPrivateNetwork = true;

		const [response, profilesAndCampaignsResponse] = yield Promise.all(
			yield [
				getPrivateNetwork(privateNetworkId),
				getAllProfilesWithCampaigns()
			]
		);

		if (response == null) {
			message.error("Failed to load private network. Unknown error", 5);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 5);
			return;
		}

		// const profilesAndCampaignsResponse = yield getAllProfilesWithCampaigns();

		if (profilesAndCampaignsResponse == null) {
			message.error("Failed to load private network. Unknown error", 5);
			return;
		}

		let profiles = [];
		let campaignHasProfile = {};
		let campaignMap = {};

		for (
			var i = 0;
			i < profilesAndCampaignsResponse.campaigns.length;
			i++
		) {
			let campaign = profilesAndCampaignsResponse.campaigns[i];
			campaignMap[campaign.id] = campaign;
		}

		for (var i = 0; i < profilesAndCampaignsResponse.profiles.length; i++) {
			let profile = profilesAndCampaignsResponse.profiles[i];
			let campaign = campaignMap[profile.campaignId];
			profiles.push({
				id: `${profile.id}`,
				pId: `c${profile.campaignId}`,
				// value: `${campaign.name} ${profile.name} ${profile.id}`,
				value: `${profile.id}`,
				textValue: `${campaign.name} ${profile.name} ${profile.id}`,
				key: `${profile.id}`,
				title: profile.name
			});
			campaignHasProfile[`c${profile.campaignId}`] = true;
		}

		for (
			var i = 0;
			i < profilesAndCampaignsResponse.campaigns.length;
			i++
		) {
			let campaign = profilesAndCampaignsResponse.campaigns[i];
			if (campaignHasProfile[`c${campaign.id}`] != undefined) {
				let title = campaign.name;
				if (!title.startsWith("Campaign")) {
					title = "Campaign: " + title;
				}
				profiles.push({
					id: `c${campaign.id}`,
					value: `c${campaign.id}`,
					textValue: `${campaign.name}`,
					key: `c${campaign.id}`,
					title: title,
					selectable: false
				});
			}
		}

		this.profiles = profiles;

		this.privateNetwork = observable.object(response.privateNetwork);
		this.sites = observable.array(response.privateSites);

		this.ui.loadingPrivateNetwork = false;

		registerHandler([
			{
				path: "private_network/" + privateNetworkId,
				handler: (err, msg) => {
					if (err) {
						return;
					}
					var obj = JSON.parse(msg.body);
					// console.log("Received");
					// console.log(obj);
					if (obj.action == "PrivateSiteDeleted") {
						this.deletePrivateSites(obj.siteList);
						return;
					}
					if (obj.action == "PrivateSiteAdded") {
						this.addPrivateSites(obj.siteList);
					}
					// if (obj.action == "accountsDeleted") {
					// 	this.deleteAccounts(obj.accounts);
					// 	return;
					// }
					// if (obj.action == "accountEdited") {
					// 	this.updateAccount(obj.account);
					// }
					// if (obj.action == "accountsImported") {
					// 	this.importAccounts(obj.accounts);
					// }
				}
			}
		]);
	});
}

export default PrivateNetworkStore;
